import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

interface Auditoria {
  id: number;
  nome: string;
  descricao: string;
  dataInicio: Date;
  dataFim: Date;
  status: string;
}

interface Acao {
  id: number;
  descricao: string;
  responsavel: string;
  dataInicio: Date;
  dataTermino: Date;
  status: string;
  estado: string;
  progresso: number;
  auditoriaId: number; // Adicionar referência à auditoria
}

interface StatusAcao {
  naoConcluida: number;
  concluida: number;
  aVencer: number;
  atrasada: number;
  total: number;
}

interface ExecucaoAtividade {
  aFazer: number;
  passado: number;
  emAndamento: number;
  impedimento: number;
  concluido: number;
  cancelado: number;
  total: number;
}

interface DetalheAcao {
  id: number;
  nome: string;
  tipo: 'formulario' | 'texto' | 'arquivo';
  descricao: string;
}

@Component({
  selector: 'app-auditoria',
  templateUrl: './auditoria.component.html',
  styleUrls: ['./auditoria.component.scss']
})
export class AuditoriaComponent implements OnInit {
  Math = Math; // Adicionar Math para uso no template
  acoes: Acao[] = [];
  statusAcoes: StatusAcao = {
    naoConcluida: 5,
    concluida: 1,
    aVencer: 0,
    atrasada: 0,
    total: 6
  };
  
  execucaoAtividades: ExecucaoAtividade = {
    aFazer: 2,
    passado: 0,
    emAndamento: 3,
    impedimento: 0,
    concluido: 1,
    cancelado: 0,
    total: 6
  };

  // Propriedades para seleção de auditoria
  auditorias: Auditoria[] = [];
  auditoriaSelecionada: number | null = null;

  filtroStatus: string = 'todos';
  filtroEstado: string = 'todos';
  resultadosPorPagina: number = 10;
  paginaAtual: number = 1;
  termoBusca: string = '';
  
  acoesFiltradas: Acao[] = [];
  acoesPaginadas: Acao[] = [];
  linhasExpandidas: Set<number> = new Set();

  // Dados mockados para auditorias
  mockAuditorias: Auditoria[] = [
    {
      id: 1,
      nome: 'Acreditação ONA - Valor e Saúde',
      descricao: 'Auditoria completa para adequação à norma ISO 27001',
      dataInicio: new Date('2021-04-01'),
      dataFim: new Date('2022-12-31'),
      status: 'em_andamento'
    },
    {
      id: 2,
      nome: 'Auditoria de Segurança da Informação - Q1 2024',
      descricao: 'Auditoria trimestral de segurança da informação',
      dataInicio: new Date('2024-01-01'),
      dataFim: new Date('2024-03-31'),
      status: 'concluida'
    },
    {
      id: 3,
      nome: 'Auditoria de Conformidade LGPD',
      descricao: 'Auditoria de conformidade com a Lei Geral de Proteção de Dados',
      dataInicio: new Date('2024-02-01'),
      dataFim: new Date('2024-06-30'),
      status: 'em_andamento'
    },
    {
      id: 4,
      nome: 'Auditoria de Controles Internos',
      descricao: 'Auditoria dos controles internos de TI',
      dataInicio: new Date('2024-03-01'),
      dataFim: new Date('2024-05-31'),
      status: 'a_fazer'
    }
  ];

  // Dados mockados para demonstração
  mockAcoes: Acao[] = [
    {
      id: 1,
      descricao: 'Revisão de conformidade e ações corretivas',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-11-01'),
      dataTermino: new Date('2022-08-31'),
      status: 'a_fazer',
      estado: 'Não-concluída',
      progresso: 0,
      auditoriaId: 1
    },
    {
      id: 2,
      descricao: 'Implementar programa ISMS',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-07-01'),
      dataTermino: new Date('2022-07-29'),
      status: 'a_fazer',
      estado: 'Não-concluída',
      progresso: 0,
      auditoriaId: 1
    },
    {
      id: 3,
      descricao: 'Avaliação de riscos',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-05-17'),
      dataTermino: new Date('2022-08-01'),
      status: 'em_andamento',
      estado: 'Não-concluída',
      progresso: 45,
      auditoriaId: 1
    },
    {
      id: 4,
      descricao: 'Preparar declaração de aplicabilidade (SOA)',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-05-17'),
      dataTermino: new Date('2022-05-31'),
      status: 'em_andamento',
      estado: 'Não-concluída',
      progresso: 60,
      auditoriaId: 1
    },
    {
      id: 5,
      descricao: 'Inventariar ativos de informação',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-04-23'),
      dataTermino: new Date('2021-05-14'),
      status: 'concluido',
      estado: 'Concluída',
      progresso: 100,
      auditoriaId: 1
    },
    {
      id: 6,
      descricao: 'Definição do escopo ISMS',
      responsavel: 'jeferson',
      dataInicio: new Date('2021-04-01'),
      dataTermino: new Date('2022-04-29'),
      status: 'em_andamento',
      estado: 'Não-concluída',
      progresso: 30,
      auditoriaId: 1
    },
    // Ações para Auditoria 2 (Q1 2024)
    {
      id: 7,
      descricao: 'Revisão de políticas de segurança',
      responsavel: 'maria',
      dataInicio: new Date('2024-01-01'),
      dataTermino: new Date('2024-01-15'),
      status: 'concluido',
      estado: 'Concluída',
      progresso: 100,
      auditoriaId: 2
    },
    {
      id: 8,
      descricao: 'Auditoria de acessos',
      responsavel: 'joao',
      dataInicio: new Date('2024-01-16'),
      dataTermino: new Date('2024-01-31'),
      status: 'concluido',
      estado: 'Concluída',
      progresso: 100,
      auditoriaId: 2
    },
    {
      id: 9,
      descricao: 'Teste de backup e recuperação',
      responsavel: 'ana',
      dataInicio: new Date('2024-02-01'),
      dataTermino: new Date('2024-02-28'),
      status: 'concluido',
      estado: 'Concluída',
      progresso: 100,
      auditoriaId: 2
    },
    // Ações para Auditoria 3 (LGPD)
    {
      id: 10,
      descricao: 'Mapeamento de dados pessoais',
      responsavel: 'carlos',
      dataInicio: new Date('2024-02-01'),
      dataTermino: new Date('2024-03-31'),
      status: 'em_andamento',
      estado: 'Não-concluída',
      progresso: 70,
      auditoriaId: 3
    },
    {
      id: 11,
      descricao: 'Revisão de consentimentos',
      responsavel: 'lucia',
      dataInicio: new Date('2024-03-01'),
      dataTermino: new Date('2024-04-30'),
      status: 'em_andamento',
      estado: 'Não-concluída',
      progresso: 40,
      auditoriaId: 3
    },
    {
      id: 12,
      descricao: 'Implementação de controles LGPD',
      responsavel: 'pedro',
      dataInicio: new Date('2024-04-01'),
      dataTermino: new Date('2024-06-30'),
      status: 'a_fazer',
      estado: 'Não-concluída',
      progresso: 0,
      auditoriaId: 3
    },
    // Ações para Auditoria 4 (Controles Internos)
    {
      id: 13,
      descricao: 'Análise de riscos de TI',
      responsavel: 'fernanda',
      dataInicio: new Date('2024-03-01'),
      dataTermino: new Date('2024-03-31'),
      status: 'a_fazer',
      estado: 'Não-concluída',
      progresso: 0,
      auditoriaId: 4
    },
    {
      id: 14,
      descricao: 'Revisão de procedimentos',
      responsavel: 'roberto',
      dataInicio: new Date('2024-04-01'),
      dataTermino: new Date('2024-04-30'),
      status: 'a_fazer',
      estado: 'Não-concluída',
      progresso: 0,
      auditoriaId: 4
    }
  ];

  // Dados mockados para detalhes das ações
  mockDetalhesAcoes: { [acaoId: number]: DetalheAcao[] } = {
    1: [
      { id: 1, nome: 'Política de Segurança', tipo: 'formulario', descricao: 'Formulário para definição da política de segurança da informação' },
      { id: 2, nome: 'Análise de Riscos', tipo: 'texto', descricao: 'Documento de análise de riscos da organização' },
      { id: 3, nome: 'Procedimentos de Backup', tipo: 'arquivo', descricao: 'Arquivo com procedimentos de backup e recuperação' }
    ],
    2: [
      { id: 4, nome: 'Controles de Acesso', tipo: 'formulario', descricao: 'Formulário para mapeamento dos controles de acesso' },
      { id: 5, nome: 'Treinamento de Usuários', tipo: 'texto', descricao: 'Material de treinamento para conscientização' }
    ],
    3: [
      { id: 6, nome: 'Avaliação de Vulnerabilidades', tipo: 'formulario', descricao: 'Checklist de avaliação de vulnerabilidades' },
      { id: 7, nome: 'Relatório de Riscos', tipo: 'arquivo', descricao: 'Relatório detalhado de análise de riscos' }
    ],
    4: [
      { id: 8, nome: 'Declaração de Aplicabilidade', tipo: 'formulario', descricao: 'Formulário SOA - Statement of Applicability' },
      { id: 9, nome: 'Controles Selecionados', tipo: 'texto', descricao: 'Lista de controles selecionados para implementação' }
    ],
    5: [
      { id: 10, nome: 'Inventário de Ativos', tipo: 'formulario', descricao: 'Formulário para inventário de ativos de informação' },
      { id: 11, nome: 'Classificação de Ativos', tipo: 'texto', descricao: 'Critérios de classificação dos ativos' }
    ],
    6: [
      { id: 12, nome: 'Escopo do ISMS', tipo: 'formulario', descricao: 'Formulário para definição do escopo do ISMS' },
      { id: 13, nome: 'Limites Organizacionais', tipo: 'texto', descricao: 'Documentação dos limites organizacionais' }
    ]
  };

  constructor(
    private fb: FormBuilder,
    public modalService: NgbModal,
    private ajax: AjaxService,
    private util: UtilService
  ) {
    
  }

  ngOnInit(): void {
    this.carregarAuditorias();
    this.carregarDados();
    this.aplicarFiltros();
  }

  carregarAuditorias() {
    // Simular carregamento de auditorias da API
    this.auditorias = [...this.mockAuditorias];
    // Selecionar a primeira auditoria por padrão
    if (this.auditorias.length > 0) {
      this.auditoriaSelecionada = this.auditorias[0].id;
    }
  }

  carregarDados() {
    // Simular carregamento de dados da API
    this.util.showLoading();
    
    setTimeout(() => {
      // Filtrar ações baseado na auditoria selecionada
      if (this.auditoriaSelecionada) {
        this.acoes = this.mockAcoes.filter(acao => acao.auditoriaId === this.auditoriaSelecionada);
      } else {
        this.acoes = [...this.mockAcoes];
      }
      this.util.closeLoading();
      this.calcularStatusAcoes();
      this.calcularExecucaoAtividades();
      this.aplicarFiltros();
    }, 1000);
  }

  calcularStatusAcoes() {
    const naoConcluida = this.acoes.filter(acao => acao.estado === 'Não-concluída').length;
    const concluida = this.acoes.filter(acao => acao.estado === 'Concluída').length;
    const aVencer = this.acoes.filter(acao => 
      acao.status === 'a_fazer' && acao.dataTermino > new Date()
    ).length;
    const atrasada = this.acoes.filter(acao => 
      acao.status !== 'concluido' && acao.dataTermino < new Date()
    ).length;
    
    this.statusAcoes = {
      naoConcluida,
      concluida,
      aVencer,
      atrasada,
      total: this.acoes.length
    };
  }

  calcularExecucaoAtividades() {
    const aFazer = this.acoes.filter(acao => acao.status === 'a_fazer').length;
    const passado = this.acoes.filter(acao => 
      acao.status === 'concluido' && acao.dataTermino < new Date()
    ).length;
    const emAndamento = this.acoes.filter(acao => acao.status === 'em_andamento').length;
    const impedimento = this.acoes.filter(acao => acao.status === 'impedimento').length;
    const concluido = this.acoes.filter(acao => acao.status === 'concluido').length;
    const cancelado = this.acoes.filter(acao => acao.status === 'cancelado').length;
    
    this.execucaoAtividades = {
      aFazer,
      passado,
      emAndamento,
      impedimento,
      concluido,
      cancelado,
      total: this.acoes.length
    };
  }

  onAuditoriaChange() {
    this.carregarDados();
  }

  getAuditoriaSelecionada(): Auditoria | null {
    return this.auditorias.find(aud => aud.id === this.auditoriaSelecionada) || null;
  }

  getStatusAuditoriaClass(status: string): string {
    switch (status) {
      case 'a_fazer':
        return 'status-a-fazer';
      case 'em_andamento':
        return 'status-em-andamento';
      case 'concluida':
        return 'status-concluido';
      default:
        return 'status-default';
    }
  }

  getStatusAuditoriaLabel(status: string): string {
    switch (status) {
      case 'a_fazer':
        return 'A fazer';
      case 'em_andamento':
        return 'Em andamento';
      case 'concluida':
        return 'Concluída';
      default:
        return status;
    }
  }

  aplicarFiltros() {
    this.acoesFiltradas = this.acoes.filter(acao => {
      const matchStatus = this.filtroStatus === 'todos' || acao.status === this.filtroStatus;
      const matchEstado = this.filtroEstado === 'todos' || acao.estado === this.filtroEstado;
      const matchBusca = !this.termoBusca || 
        acao.descricao.toLowerCase().includes(this.termoBusca.toLowerCase()) ||
        acao.responsavel.toLowerCase().includes(this.termoBusca.toLowerCase());
      
      return matchStatus && matchEstado && matchBusca;
    });

    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  atualizarPaginacao() {
    const inicio = (this.paginaAtual - 1) * this.resultadosPorPagina;
    const fim = inicio + this.resultadosPorPagina;
    this.acoesPaginadas = this.acoesFiltradas.slice(inicio, fim);
  }

  onFiltroStatusChange() {
    this.aplicarFiltros();
  }

  onFiltroEstadoChange() {
    this.aplicarFiltros();
  }

  onResultadosPorPaginaChange() {
    this.aplicarFiltros();
  }

  onBuscaChange() {
    this.aplicarFiltros();
  }

  paginaAnterior() {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.atualizarPaginacao();
    }
  }

  proximaPagina() {
    const totalPaginas = Math.ceil(this.acoesFiltradas.length / this.resultadosPorPagina);
    if (this.paginaAtual < totalPaginas) {
      this.paginaAtual++;
      this.atualizarPaginacao();
    }
  }

  irParaPagina(pagina: number) {
    this.paginaAtual = pagina;
    this.atualizarPaginacao();
  }

  getTotalPaginas(): number {
    return Math.ceil(this.acoesFiltradas.length / this.resultadosPorPagina);
  }

  getPaginas(): number[] {
    const totalPaginas = this.getTotalPaginas();
    const paginas: number[] = [];
    
    for (let i = 1; i <= totalPaginas; i++) {
      paginas.push(i);
    }
    
    return paginas;
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'a_fazer':
        return 'status-a-fazer';
      case 'em_andamento':
        return 'status-em-andamento';
      case 'concluido':
        return 'status-concluido';
      case 'impedimento':
        return 'status-impedimento';
      case 'cancelado':
        return 'status-cancelado';
      default:
        return 'status-default';
    }
  }

  getStatusIcon(status: string): string {
    switch (status) {
      case 'a_fazer':
        return 'fas fa-square';
      case 'em_andamento':
        return 'fas fa-play';
      case 'concluido':
        return 'fas fa-check';
      case 'impedimento':
        return 'fas fa-exclamation-triangle';
      case 'cancelado':
        return 'fas fa-times';
      default:
        return 'fas fa-circle';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'a_fazer':
        return 'A fazer';
      case 'em_andamento':
        return 'Em andamento';
      case 'concluido':
        return 'Concluído';
      case 'impedimento':
        return 'Impedimento';
      case 'cancelado':
        return 'Cancelado';
      default:
        return status;
    }
  }

  visualizarDetalhes(acao: Acao) {
    console.log('Visualizar detalhes da ação:', acao);
    // Implementar navegação para detalhes
  }

  imprimirRelatorio() {
    console.log('Imprimir relatório');
    // Implementar funcionalidade de impressão
  }

  // Cálculos para gráficos
  getPercentualNaoConcluida(): number {
    return (this.statusAcoes.naoConcluida / this.statusAcoes.total) * 100;
  }

  getPercentualConcluida(): number {
    return (this.statusAcoes.concluida / this.statusAcoes.total) * 100;
  }

  getPercentualAFazer(): number {
    return (this.execucaoAtividades.aFazer / this.execucaoAtividades.total) * 100;
  }

  getPercentualEmAndamento(): number {
    return (this.execucaoAtividades.emAndamento / this.execucaoAtividades.total) * 100;
  }

  getPercentualConcluido(): number {
    return (this.execucaoAtividades.concluido / this.execucaoAtividades.total) * 100;
  }

  // Métodos para expandir/colapsar linhas
  toggleLinha(acaoId: number) {
    if (this.linhasExpandidas.has(acaoId)) {
      this.linhasExpandidas.delete(acaoId);
    } else {
      this.linhasExpandidas.add(acaoId);
    }
  }

  isLinhaExpandida(acaoId: number): boolean {
    return this.linhasExpandidas.has(acaoId);
  }

  getIconeExpandir(acaoId: number): string {
    return this.isLinhaExpandida(acaoId) ? 'fas fa-minus' : 'fas fa-plus';
  }

  getProgressBarClass(progresso: number): string {
    if (progresso >= 80) return 'bg-success';
    if (progresso >= 50) return 'bg-warning';
    if (progresso >= 20) return 'bg-info';
    return 'bg-secondary';
  }

  // Métodos para detalhes das ações
  getDetalhesAcao(acaoId: number): DetalheAcao[] {
    return this.mockDetalhesAcoes[acaoId] || [];
  }

  getTipoLabel(tipo: string): string {
    switch (tipo) {
      case 'formulario':
        return 'Formulário';
      case 'texto':
        return 'Texto';
      case 'arquivo':
        return 'Arquivo';
      default:
        return tipo;
    }
  }

  getTipoIcon(tipo: string): string {
    switch (tipo) {
      case 'formulario':
        return 'fas fa-clipboard-list';
      case 'texto':
        return 'fas fa-file-alt';
      case 'arquivo':
        return 'fas fa-file-upload';
      default:
        return 'fas fa-file';
    }
  }

  getTipoClass(tipo: string): string {
    switch (tipo) {
      case 'formulario':
        return 'tipo-formulario';
      case 'texto':
        return 'tipo-texto';
      case 'arquivo':
        return 'tipo-arquivo';
      default:
        return 'tipo-default';
    }
  }

  responderDetalhe(detalhe: DetalheAcao) {
    console.log('Responder detalhe:', detalhe);
    // Implementar funcionalidade de resposta
  }
}
